import apiClient from "./axiosConfig";

// Data for the Settings hub that has no other wrapper yet.

export type LoginLocation =
  | string
  | {
      city?: string | null;
      region?: string | null;
      country?: string | null;
      label?: string | null;
      lat?: number | null;
      lng?: number | null;
    }
  | null;

export interface LoginHistoryEntry {
  timestamp: string;
  ip?: string | null;
  location?: LoginLocation;
  username?: string | null;
  user?: {
    _id?: string;
    name?: string | null;
    userName?: string | null;
    email?: string | null;
  } | null;
  status?: string | null;
  success?: boolean | null;
}

/** GET /api/rbac/users/:id/logins (needs userManagement:read), newest first. */
export const fetchLoginHistory = async (userId: string): Promise<LoginHistoryEntry[]> => {
  const res = await apiClient.get<LoginHistoryEntry[]>(
    `/api/rbac/users/${encodeURIComponent(userId)}/logins`
  );
  const list = Array.isArray(res.data) ? [...res.data] : [];
  return list.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
};
